'use client'
import { cn } from '@/lib/utils'

import type { PlacardCalculatorType } from '@/types/contentful/placardCalculatorType'

export const PlacardCalculator = ({ title, height }: PlacardCalculatorType) => {
  return (
    <section data-name="placard-calculator" className={cn('w-full bg-grey-100 px-4 py-8 md:px-12 md:py-16 lg:px-28 lg:py-24 xl:px-30')}>
      <h3 className="mb-3.5 mt-5 text-center text-lg font-semibold">{title ?? 'Placard Calculator'}</h3>
      <iframe title="Placard Calculator" src="https://placard.supagas.net.au/" width="100%" height={height ?? '638px'} loading="lazy" allowFullScreen></iframe>
    </section>
  )
}
